import { useSelector } from 'react-redux'
import { positionDropdown } from '../../../../../common/dropdown'
import { Element } from '../../../../../common/html/element'
import { Separator } from '../../../../../common/separator'
import { Tooltip } from '../../../../../common/tooltip'
import { formatDataByUnit, isPercentFormat } from './helper'

const CellWithSeparation = ({
  val,
  colId,
  rowId,
  isDynamicReport,
  backgroundColor,
  formatCurrency,
}) => {
  const locale = useSelector((state) => state.i18n.locale)

  if (isDynamicReport) return null

  return (
    <td
      style={{
        backgroundColor,
      }}
    >
      {val && (
        <Tooltip
          tooltipContent="portfolio.finance.MAX_MIN_RATIO"
          isI18n={true}
          position={positionDropdown.BOTTOM_CENTER}
          tooltipContentStyle={{
            backgroundColor: '#1E242E',
            opacity: 1,
            color: '#ECECEC',
          }}
        >
          <Element className="dFlex justifyContentCenter alignItemsCenter">
            {formatDataByUnit(rowId, colId, val.min, formatCurrency, locale)}
            {isPercentFormat(val.min, rowId) ? '%' : ''}
            <Separator
              margin={'0 8px'}
              height={16}
              width={1}
              backgroundColor="#9C9C9C"
            />
            {formatDataByUnit(rowId, colId, val.max, formatCurrency, locale)}
            {isPercentFormat(val.max, rowId) ? '%' : ''}
          </Element>
        </Tooltip>
      )}
    </td>
  )
}

export default CellWithSeparation
